import headerImage from '../../../styles/img/upsellEc/infography-img.png';
import horseIcon from '../../../styles/img/upsellEc/horse-icon.svg';
import softwareIcon from '../../../styles/img/upsellEc/software-icon.svg';
import userIcon from '../../../styles/img/upsellEc/user-icon.svg';
import ecPhoto from '../../../styles/img/upsellEc/ec-photo.png';
import rulerIcon from '../../../styles/img/upsellEc/ruler-icon.svg';
import phoneIcon from '../../../styles/img/upsellEc/phone-icon.svg';
import calculatorIcon from '../../../styles/img/upsellEc/calculator-icon.svg';

export const upsellEcData = {
  card:{
    monthSubscription: "100€ par mois / Mensuel",
    yearSubscription: "85€ par mois / Annuel",
    textBtn: "Ça m'intéresse",
    textLink: "Je m'occupe seul de la comptabilité"
  },
  header:{
    headerTitle: "Lancez-vous simplement, on s'occupe de votre compta",
    headerImage: headerImage,
    headerText: "Votre expert comptable disponible, réactif avec un logiciel de suivi simple et efficace pour être enfin serein sur sa compta",
  },
  content:{
    includedOptions:[
      {
        icon: horseIcon,
        optionTitle: "Expert comptable dédié",
        optionText: "Votre expert comptable dédié vous accompagne et vous conseille en permanence Les services inclus le bilan comptable, la déclaration de TVA, le suivi de trésorerie, etc"
      },
      {
        icon: softwareIcon,
        optionTitle: "Logiciel de comptabilité",
        optionText: "Nos solutions logiciels de dernière génération automatisent jusqu’à 100% de votre comptabilité. Fini les déplacements et la « paperasse ». Vous gagnez du temps !"
      },
      {
        icon: userIcon,
        optionTitle: "Hyper disponibilité",
        optionText: "Votre expert comptable est disponible et réactif pour vous aider et répondre à toutes vos questions d’ordre fiscales, sociales, gestion et juridique."
      },
    ],
    expertComptable:{
      title: "Vous êtes suivi par un véritable expert comptable",
      picture: ecPhoto,
      name: "Jean Luc Javelaud",
      description:[ 
        "Expert-comptable et commissaire aux comptes, inscrit à l’Ordre des experts comptables de Marseille depuis 1997, entouré d’une équipe de 20 collaborateurs expérimentés, ayant pour objectif d’accompagner nos clients dans la réussite de leur entreprise, de sa création à sa cession.", 
        "L’équipe de Jean Luc Javelaud possède plus de 20 ans d’expertise en fiscalité, en paie, et en gestion de patrimoine pour prendre les bonnes options fiscales et sociales."]
    },
    optionsContent:[
      {
        icon: rulerIcon,
        optionTitle: "Solution sur mesure",
        optionText: "Socic gère tous types d’entreprises : TPE, PME, Professions libérales, Holdings, … quel que soit le régime fiscal et social (SARL, SAS, EURL, SASU, …)."
      },
      {
        icon: phoneIcon,
        optionTitle: "Assistance et conseil",
        optionText: "Vous bénéficiez des conseils de nos experts spécialisés en fiscalité, en paies, et en gestion de patrimoine pour prendre les bonnes options fiscales et sociales."
      },
      {
        icon: calculatorIcon,
        optionTitle: "Comptabilité",
        optionText: "Vous bénéficiez des tous les services comptable : Déclaration de TVA, Suivi de trésorerie, Bilan comptable, financier et déclarations fiscales incluses, Liasse fiscale, Impôt société, TVA, Prélèvements sur dividendes, TVS, DSI etc."
      },
    ]
  },
  footer:{
    footerTitle:"Fonctionnlaités du logiciel de comptabilité",
    listItems:[
      "Comptabilité automatisée", 
      "Tableaux de bord", 
      "Application mobile", 
      "Gestion de la TVA", 
      "Gestion des justificatifs", 
      "Gestion commerciale"
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/buy/Upsell-EC/upsell-Ec-Data.js